var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-side-content"},[_c('div',{staticClass:"container-right p-t-20",attrs:{"id":"container-right"}},[_c('img',{staticClass:"img-fluid logo floating m-t-30",attrs:{"src":require("@/assets/images/Logos/logo-color.svg"),"alt":"Logo Pagando"}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }